import { f as a } from "./addOns-5IZhcbHD.js";
const l = {
  id: "TexasDaily4",
  name: "Daily 4",
  style: {
    colorPrimary: "#321b80",
    fireball: a
  }
};
export {
  l as default
};
